export default {
  enums: (state) => state.staticConfiguration.enums,
  enumsByType: (state) => (type) =>
    state.staticConfiguration.enums.find((enumType) => enumType.name === type)
      .values ?? {},
}
